export const environment = {
  production: true,
  recaptcha: {
    siteKey: '6LeE1yYtAAAAAFAePlcx6tN9nVK9SauPTwf-qSmj',
  },

  /*baseUrl: 'https://floridanationstarlawsui-development-dhgrgkbtfpfubncu.centralus-01.azurewebsites.net/api/'*/

  baseUrl: 'https://floridanationstarlawsuit-eeebcthnaqfyeuf6.centralus-01.azurewebsites.net/api/'

 /* baseUrl: 'https://localhost:7249/api/'*/
};

